module.exports = __webpack_public_path__ + "static/media/star10.f7be8a23.svg";